import { useEffect } from 'react';
import seoConfig from '../../utils/seoConfig';

const SEOHead = ({
  title,
  description,
  keywords,
  path = '/',
  image,
  type = 'website',
  structuredData = null,
  noindex = false
}) => {
  useEffect(() => {
    const pageTitle = title || seoConfig.site.name;
    document.title = pageTitle;

    const updateMetaTag = (selector, attribute, content) => {
      if (!content) return;

      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        if (selector.includes('property=')) {
          element.setAttribute('property', selector.match(/property="([^"]+)"/)[1]);
        } else if (selector.includes('name=')) {
          element.setAttribute('name', selector.match(/name="([^"]+)"/)[1]);
        }
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    updateMetaTag('meta[name="description"]', 'content', description || seoConfig.site.description);
    updateMetaTag('meta[name="keywords"]', 'content', keywords);

    updateMetaTag('meta[property="og:title"]', 'content', pageTitle);
    updateMetaTag('meta[property="og:description"]', 'content', description || seoConfig.site.description);
    updateMetaTag('meta[property="og:type"]', 'content', type);
    updateMetaTag('meta[property="og:url"]', 'content', `${seoConfig.site.url}${path}`);
    updateMetaTag('meta[property="og:site_name"]', 'content', seoConfig.site.name);
    updateMetaTag('meta[property="og:image"]', 'content', image || `${seoConfig.site.url}/logo512.png`);

    updateMetaTag('meta[name="twitter:card"]', 'content', 'summary_large_image');
    updateMetaTag('meta[name="twitter:site"]', 'content', seoConfig.site.twitter);
    updateMetaTag('meta[name="twitter:title"]', 'content', pageTitle);
    updateMetaTag('meta[name="twitter:description"]', 'content', description || seoConfig.site.description);
    updateMetaTag('meta[name="twitter:image"]', 'content', image || `${seoConfig.site.url}/logo512.png`);

    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', `${seoConfig.site.url}${path}`);

    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute('content', noindex ? 'noindex, nofollow' : 'index, follow');

    const existingStructuredData = document.querySelectorAll('script[type="application/ld+json"]');
    existingStructuredData.forEach(script => {
      if (script.dataset.dynamic === 'true') {
        script.remove();
      }
    });

    if (structuredData) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.dynamic = 'true';
      script.textContent = JSON.stringify(Array.isArray(structuredData) ? structuredData : [structuredData]);
      document.head.appendChild(script);
    }

  }, [title, description, keywords, path, image, type, structuredData, noindex]);

  return null;
};

export default SEOHead;
